<template>
  <div class="asset2-page-container">
    <h1>Asset2 Details</h1>
    <div class="filter-buttons">
      <label>
        <input type="radio" v-model="filter" value="all" @change="filterAssets" /> All
      </label>
      <label>
        <input type="radio" v-model="filter" value="inactive" @change="filterAssets" /> Inactive
      </label>
      <label>
        <input type="radio" v-model="filter" value="active" @change="filterAssets" /> Active
      </label>
    </div>
    <table>
      <thead>
        <tr>
          <th @click="sortAssets('devicename')">Device Name <span :class="getArrowClass('devicename')"></span></th>
          <th>Image</th>
          <th @click="sortAssets('tag_mac')">Tag ID <span :class="getArrowClass('tag_mac')"></span></th>
          <th @click="sortAssets('devicetype')">Device Type <span :class="getArrowClass('devicetype')"></span></th>
          <th @click="sortAssets('tag_temperature')">Temp <span :class="getArrowClass('tag_temperature')"></span></th>
          <th @click="sortAssets('tag_vol')">Battery <span :class="getArrowClass('tag_vol')"></span></th>
          <th @click="sortAssets('tag_rssi')">RSSI <span :class="getArrowClass('tag_rssi')"></span></th>
          <th @click="sortAssets('building')">Building <span :class="getArrowClass('building')"></span></th>
          <th @click="sortAssets('floor')">Floor <span :class="getArrowClass('floor')"></span></th>
          <th @click="sortAssets('taglocation')">Last Scanned Zone <span :class="getArrowClass('taglocation')"></span></th>
          <th @click="sortAssets('assignedzone')">Assigned Zone <span :class="getArrowClass('assignedzone')"></span></th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filteredAssets.length === 0">
          <td colspan="12">No assets found matching your search.</td>
        </tr>
        <tr v-else v-for="asset in filteredAssets" :key="asset.tag_mac">
          <td>{{ asset.devicename }}</td>
          <td><img :src="getAssetImage2()" alt="Asset Image" class="table-image" /></td>
          <td>{{ asset.tag_mac }}</td>
          <td>{{ asset.devicetype }}</td>
          <td>
            <span class="material-symbols-outlined thermostat" style="font-size: 16px;">device_thermostat</span>
            <span>{{ asset.tag_temperature }} °C</span>
          </td>
          <td>
            <span :class="getBatteryClass(asset.tag_vol)">
              {{ asset.tag_vol >= 2.7 ? 'Good' : asset.tag_vol >= 2.3 ? 'Mid' : 'None' }}
            </span>
            <span class="battery-value"> ({{ asset.tag_vol.toFixed(1) }}v)</span>
          </td>
          <td>
            <span v-if="Math.abs(asset.tag_rssi) <= 70">
              <span class="material-symbols-outlined rssi-good" style="font-size: 24px;">signal_cellular_alt</span>
            </span>
            <span v-else>
              <span class="material-symbols-outlined rssi-mid" style="font-size: 24px;">signal_cellular_alt_2_bar</span>
            </span>
          </td>
          <td>{{ asset.building }}</td>
          <td>{{ asset.floor }}</td>
          <td>{{ asset.taglocation }}</td>
          <td>{{ asset.assignedzone }}</td>
          <td>
            <button @click="openEditSidebar(asset)">EDIT</button>
          </td>
        </tr>
      </tbody>
    </table>

    <EditAssetPage2
      v-if="selectedAsset" 
      :visible="isEditSidebarVisible"
      :asset="selectedAsset"
      @save="updateAsset"
      @close="closeEditSidebar"
    />
  </div>
</template>

<script>
import axios from 'axios';
import EditAssetPage2 from './EditAssetPage2.vue';

export default {
  components: {
    EditAssetPage2,
  },
  data() {
    return {
      filter: 'all',
      assets: [],
      filteredAssets: [],
      sortKey: 'tag_mac',
      sortOrder: 1,
      isEditSidebarVisible: false,
      selectedAsset: null,
      autoRefreshInterval: null,
    };
  },
  created() {
    const filterFromRoute = this.$route.query.filter || 'all';
    this.filter = filterFromRoute;
    this.loadAssets();
    this.checkActiveStatus();
    this.autoRefreshInterval = setInterval(this.loadAssets, 5000);
  },
  beforeUnmount() {
    clearInterval(this.autoRefreshInterval);
  },
  methods: {
    loadAssets() {
      axios.get('/api/assets2')
        .then((response) => {
          this.assets = response.data;
          this.filterAssets();
          
        })
        .catch((error) => {
          console.error('자산을 불러오지 못했습니다:', error);
          this.assets = [];
          this.filteredAssets = [];
        });
    },
    filterAssets() {
      this.filteredAssets = this.assets.filter(asset => asset.devicename !== null);

      if (this.filter === 'inactive') {
        this.filteredAssets = this.filteredAssets.filter(asset => asset.active === -1);
      } else if (this.filter === 'active') {
        this.filteredAssets = this.filteredAssets.filter(asset => asset.active === 0);
      }
      this.sortAssets(this.sortKey, true);
    },
    sortAssets(key, keepOrder = false) {
      if (!keepOrder) {
        this.sortOrder = this.sortKey === key ? -this.sortOrder : 1;
      }
      this.sortKey = key;
      this.filteredAssets.sort((a, b) => {
        if (a[key] < b[key]) return -1 * this.sortOrder;
        if (a[key] > b[key]) return 1 * this.sortOrder;
        return 0;
      });
    },
    checkActiveStatus() {
      axios.post('/api/checkactive/tag').then((response) => {
        console.log('Active 상태가 업데이트되었습니다:', response.data.message);
      }).catch(error => {
        console.error('Failed to check active status:', error);
      });
    },
    getArrowClass(key) {
      return this.sortKey === key ? (this.sortOrder === 1 ? 'arrow-up' : 'arrow-down') : 'arrow-default';
    },
    getAssetImage2() {
      console.log('getAssetImage2 호출, asset:', this.asset);
      if (!this.asset?.tag_mac) {
        console.log('기본 이미지 반환');
        return require('@/assets/inventory.png');
      }
      const imageUrl = `/api/asset-image2/${this.asset.tag_mac}`;
      console.log('생성된 이미지 URL:', imageUrl);
      return `${imageUrl}?t=${new Date().getTime()}`;
    },
    getBatteryClass(vol) {
      return vol >= 2.7 ? 'battery_good' : vol >= 2.3 ? 'battery_mid' : 'battery_none';
    },
    openEditSidebar(asset) {
      this.selectedAsset = asset;
      this.isEditSidebarVisible = true;
    },
    closeEditSidebar() {
      this.isEditSidebarVisible = false;
      this.selectedAsset = null;
    },
    updateAsset(assetData) {
      console.log('updateAsset 호출됨');
      console.log('전송할 데이터:', assetData);
      
      axios.post('/api/updateAssetDetails2', assetData)
        .then(response => {
          console.log('업데이트 응답:', response.data);
          this.closeEditSidebar();
          this.loadAssets();
        })
        .catch(error => {
          console.error('업데이트 에러:', error.response || error);
        });
    },
  },
};
</script>

<style scoped>
.asset2-page-container {
  padding: 20px;
}

.filter-buttons {
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
}

th,
td {
  padding: 10px;
  border: 1px solid #ddd;
}

th {
  background-color: #f4f4f4;
  text-align: left;
  cursor: pointer;
  position: relative;
}

th .arrow-default::after {
  content: '▼';
}

th .arrow-up::after {
  content: '▲';
}

th .arrow-down::after {
  content: '▼';
}

table img {
  width: 40px; /* 고정 너비 */
  height: 60px; /* 고정 높이 */
  object-fit: contain; /* 비율 유지 */
}

.battery_good {
  color: green;
  font-weight: bold;
}

.battery_mid {
  color: orange;
  font-weight: bold;
}

.battery_none {
  color: skyblue;
  font-weight: bold;
}

.rssi-good {
  color: green;
}

.rssi-mid {
  color: orange;
}

.rssi-low {
  color: red;
}

.thermostat {
  color: red;
}

.battery-value {
  color: black;
}
</style>
